import { createAsyncThunk } from '@reduxjs/toolkit';
import MarketSnapshotAPI from './marketSnapshotAPI';

export const fetchMarketOverview = createAsyncThunk(
  'marketSnapshot/fetchAll',
  async (_, thunkAPI) => {
    try {
      return await MarketSnapshotAPI.fetchAll();
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTopMovers = createAsyncThunk(
  'marketSnapshot/fetchTopMovers',
  async (_, thunkAPI) => {
    try {
      return await MarketSnapshotAPI.fetchTopMovers();
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTopGainers = createAsyncThunk(
  'marketSnapshot/fetchTopGainers',
  async (_, thunkAPI) => {
    try {
      return await MarketSnapshotAPI.fetchTopGainers();
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTopLosers = createAsyncThunk(
  'marketSnapshot/fetchTopLosers',
  async (_, thunkAPI) => {
    try {
      return await MarketSnapshotAPI.fetchTopLosers();
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Added: Missing fetchMostActive action
export const fetchMostActive = createAsyncThunk(
  'marketSnapshot/fetchMostActive',
  async (_, thunkAPI) => {
    try {
      return await MarketSnapshotAPI.fetchMostActive();
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Added: Missing fetchSingleSnapshot action
export const fetchSingleSnapshot = createAsyncThunk(
  'marketSnapshot/fetchSingleSnapshot',
  async (symbol, thunkAPI) => {
    try {
      return await MarketSnapshotAPI.fetchSingleSnapshot(symbol);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);


// watchlist: array of {symbol, name, ...}
export const fetchBatchSnapshots = createAsyncThunk(
  'marketSnapshot/fetchBatchSnapshots',
  async (symbols, { rejectWithValue }) => {
    try {
      const data = await MarketSnapshotAPI.fetchBatchSnapshots(symbols);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message);
    }
  }
);